__turbopack_context__.v({
  "container": "NavDropdownPanel-module-scss-module__7uP5OG__container",
  "dropdown": "NavDropdownPanel-module-scss-module__7uP5OG__dropdown",
  "latestNews": "NavDropdownPanel-module-scss-module__7uP5OG__latestNews",
  "services": "NavDropdownPanel-module-scss-module__7uP5OG__services",
});
